{
  "back": "Atrás",
  "form": "Formulario",
  "purposeTitle": "¿Cuál es el propósito de tu parada?",
  "appointmentInfoTitle": "Información de la cita",
  "appointmentInfoHint": "Asegúrate de completar este campo si tienes una cita.",
  "checkInDetailsTitle": "Detalles del registro",
  "checkInDetailsHint": "Información adicional sobre tu visita.",
  "driverPhoneLabel": "Número de teléfono del conductor",
  "activateWhatsAppTitle": "Activar mensajería de WhatsApp",
  "activateWhatsAppBody": "Para chatear con el almacén, responde \"OK\" cuando te enviemos el primer mensaje de WhatsApp.",
  "whatsappDelayBanner": "El primer mensaje de WhatsApp puede tardar hasta un minuto en llegar.",
  "notesLabel": "Notas",
  "notesPlaceholder": "¿Alguna instrucción especial o nota para la instalación?",
  "addNoteToWarehouse": "Agregar nota para el almacén",
  "verifyAndCheckIn": "Verificar y registrarse",
  "completeCheckIn": "Completar registro",
  "visitGroupInbound": "Entrante",
  "visitGroupOutbound": "Saliente",
  "visitGroupBoth": "Entrante y saliente",
  "visitUnloadTruck": "Descargar mi camión",
  "visitDropTrailer": "Dejar mi remolque o contenedor",
  "visitLoadTruck": "Cargar mi camión",
  "visitHookTrailer": "Enganchar un remolque o contenedor",
  "visitUnloadLoad": "Descargar y cargar mi camión",
  "visitDropHook": "Dejar y enganchar un remolque o contenedor",
  "containerTrailer": "Remolque",
  "containerContainer": "Contenedor",
  "containerOversized": "Sobredimensionado",
  "containerOther": "Otro",
  "defaultReferenceName": "Número de orden de compra",
  "identifierSuffix": "{reference} o número de confirmación",
  "licenseOrDotRequired": "Por favor llena la placa o el número DOT",
  "appointmentNotFound": "No pudimos localizar tu cita",
  "referenceNotFound": "No se encontró una cita coincidente. Los números de referencia distinguen entre mayúsculas y minúsculas.",
  "referenceCaseSensitiveHint": "El número de referencia distingue entre mayúsculas y minúsculas",
  "messaging": {
    "whatsappFailedTitle": "No se pudo enviar el mensaje de WhatsApp",
    "smsFailedTitle": "No se pudo enviar el mensaje SMS",
    "whatsappFailedBody": "No pudimos enviar un mensaje a {displayPhone}. <br /><br /> Si anteriormente te diste de baja, por favor envía START a <a href='{waUrl}' target='_blank' rel=\"noopener noreferrer\">{senderPhone}</a> para comenzar a recibir mensajes de este almacén.",
    "smsFailedBody": "No pudimos enviar un mensaje a {displayPhone}. <br /><br /> Si anteriormente te diste de baja, por favor envía START a <a href='{smsUrl}'>{senderPhone}</a> para comenzar a recibir mensajes SMS de este almacén.",
    "fallbackPhone": "el número de teléfono proporcionado"
  }
}
